<template>
	<div class="row">
		<div class="column-3 item">
			<v-search-left @changeFiltros="changeFiltros" :filtros="[]"></v-search-left>
		</div>
    	<div class="column-9 item">
			<h2>Dados do pedido</h2>
			<div class="desc">
				<span><b>Protocolo:</b> {{ pedido.protocolo }}</span>
				<span><b>Data/Hora de criação:</b> {{ pedido.created_at }}</span>
				<span><b>Data/Hora de alteração:</b> {{ pedido.updated_at }}</span>
				<span><b>CNPJ do Cliente:</b> {{ pedido.cliente.cnpj }}</span>
				<span><b>Código do Cliente:</b> {{ pedido.cliente.codigo }}</span>
				<span><b>Razão Social do Cliente:</b> {{ pedido.cliente.nome }}</span>
				<span><b>Endereço do Cliente:</b> {{ pedido.cliente.endereco }}, {{ pedido.cliente.bairro }} - {{ pedido.cliente.cidade }}/{{ pedido.cliente.estado }} - CEP: {{ pedido.cliente.cep }}</span>
				<span><b>Telefone do Cliente:</b> <the-mask :mask="['(##) ####-####', '(##) #####-####']" v-model="pedido.cliente.telefone" class="phone-disabled" disabled readonly /></span>
				<span><b>E-mail do Cliente:</b> {{ pedido.emailPrincipal }}</span>
				<span><b>Empresa de Representação (Razão Social):</b> {{ pedido.representante.razao_social }}</span>
				<span><b>Código SAP da Empresa de Representação:</b> {{ pedido.representante.codigo_sap }}</span>
				<span><b>CNPJ da Empresa de representação:</b> {{ pedido.representante.cnpj_representante }}</span>
				<span><b>Preposto:</b>{{ pedido.desc_preposto }}</span>
                <span><b>Código SAP do Preposto:</b>{{ pedido.cod_preposto }}</span>
			</div>
			<div class="title">ITENS DO PEDIDO</div>
			<div class="box-overflow">
				<table class="padrao">
					<thead>
						<tr>
							<!-- <td></td> -->
							<td>Foto</td>
							<td>Referência e descrição</td>								
							<td>UN.</td>
							<td>QTD. P/ Emb.</td>
							<td width="20px">QTD.</td>
							<td>preço un.</td>
							<td>total s/ imposto</td>
							<td>ICMS (%)</td>
							<td>IPI (%)</td>
							<td>ST (%)</td>
							<td>total c/ imposto</td>
							<td v-if="canEdit()"></td>
						</tr>
					</thead>
					<tbody v-for="produto in pedido.produtos">
						<tr>							
							<td class="foto">
								<img :src="produto.produto.fotos[0] ? produto.produto.fotos[0].miniatura_cropped : ''" alt="" height="50px">
							</td>								
							<td>								
								<div class="box-reference-description">     
									<div class="box-image">                                           
										<img v-if="produto.new_item_order" :src="root + '/public/images/menu-novidade.png'" />
									</div>

									<div class="box-name-product">
										<div class="ref">{{ produto.produto.referencia }}</div>
										<div class="nome-produto">{{ produto.produto.nome }}</div>
									</div>
                            	</div>
							</td>
							<td>{{ produto.produto.unidade_basica }}</td>
							<td>{{ parseInt(produto.produto.embalagem) }}</td>
				
							<td v-if="canEdit()">
								<div class="pedido-detalhe-box-quantidade-produto">
									<button type="button" @click="updateQuantity(produto, 'remove')">
										<i class="fas fa-minus"></i>
									</button>

									<div class="quantidade">{{ produto.quantidade }}</div>

									<button type="button" @click="updateQuantity(produto, 'add')">
										<i class="fas fa-plus"></i>
									</button>
								</div>
							</td>

							<td v-if="!canEdit()">{{ produto.quantidade }}</td>								

							<td><span v-if="showValue(produto)">R$ {{ getPrecoLiquido(produto) | currency }}</span></td>
							<td><span v-if="showValue(produto)">R$ {{ getTotal(produto) | currency }}</span></td>
							<td><span v-if="showValue(produto)">{{ produto.perc_icms }}</span></td>
							<td><span v-if="showValue(produto)">{{ produto.perc_ipi }}</span></td>
							<td><span v-if="showValue(produto)">{{ formatarValor(produto.perc_st) }}</span></td>
							<td><span v-if="showValue(produto)">R$ {{ getTotal(produto, true) | currency }}</span></td>
							<td v-if="canEdit()">
								<a href="#" @click.prevent="removeItem(produto)">
									<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="26px">
										<path fill-rule="evenodd" fill="rgb(37, 38, 66)"
											d="M20.308,9.608 L20.308,23.562 C20.306,24.908 19.171,
											25.998 17.769,26.000 L4.231,26.000 C2.829,25.998 1.694,
											24.908 1.692,23.562 L1.692,9.608 C0.679,9.263 0.002,
											8.344 -0.000,7.312 L-0.000,5.687 C0.001,4.342 1.137,
											3.251 2.538,3.250 L7.615,3.250 L7.615,0.812 C7.615,
											0.364 7.994,-0.000 8.461,-0.000 L13.538,-0.000 C14.006,
											-0.000 14.384,0.364 14.384,0.812 L14.384,3.250 L19.461,
											3.250 C20.863,3.251 21.999,4.342 22.000,5.687 L22.000,
											7.312 C21.998,8.344 21.320,9.263 20.308,9.608 ZM3.384,
											23.562 C3.384,24.011 3.763,24.375 4.231,24.375 L17.769,
											24.375 C18.236,24.375 18.615,24.011 18.615,23.562 L18.615,
											9.750 L3.384,9.750 L3.384,23.562 ZM12.692,1.625 L9.308,
											1.625 L9.308,3.250 L12.692,3.250 L12.692,1.625 ZM20.308,
											5.687 C20.308,5.239 19.929,4.875 19.461,4.875 L2.538,
											4.875 C2.071,4.875 1.692,5.239 1.692,5.687 L1.692,
											7.312 C1.692,7.761 2.071,8.125 2.538,8.125 L19.461,
											8.125 C19.929,8.125 20.308,7.761 20.308,7.312 L20.308,
											5.687 ZM14.384,22.852 C13.917,22.852 13.538,22.488 13.538,
											22.040 L13.538,12.257 C13.538,11.809 13.917,11.445 14.384,
											11.445 C14.852,11.445 15.231,11.809 15.231,12.257 L15.231,
											22.040 C15.231,22.488 14.852,22.852 14.384,22.852 ZM11.000,
											22.852 C10.533,22.852 10.154,22.488 10.154,22.040 L10.154,
											12.257 C10.154,11.809 10.533,11.445 11.000,11.445 C11.467,
											11.445 11.846,11.809 11.846,12.257 L11.846,22.040 C11.846,
											22.488 11.467,22.852 11.000,22.852 ZM7.615,22.852 C7.148,
											22.852 6.769,22.488 6.769,22.040 L6.769,12.257 C6.769,
											11.809 7.148,11.445 7.615,11.445 C8.083,11.445 8.461,
											11.809 8.461,12.257 L8.461,22.040 C8.461,22.488 8.083,
											22.852 7.615,22.852 Z"/>
									</svg>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				
				<a class="pedido-link-back-select-itens" :href="app + '/meus-pedidos/atualizar-pedido/' + pedido.id" v-if="canEdit() && !isCustomerTypeSale">
					Adicionar / Atualizar itens no pedido
				</a>
			</div>
			<div class="box-resumo-pedido">
				<div class="title">Resumo do pedido</div>
				<div class="box-overflow">
					<table class="padrao">
						<thead>
							<tr>
								<td>Itens adicionados</td>
								<td>Total em produtos</td>
								<td>R$ IPI</td>
								<td>R$ ST</td>
								<td>Valor total do Pedido</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ pedido.produtos.length }}</td>
								<td><span v-if="showResumeValue()">R$ {{ this.totalAmount | currency }}</span></td>
								<td><span v-if="showResumeValue()">R$ {{ this.totalIpi | currency }}</span></td>
								<td><span v-if="showResumeValue()">R$ {{ this.totalSt | currency }}</span></td>
								<td v-if="pedido.ultimo_status && pedido.ultimo_status.slug !== 'orcamento-enviado-preposto'">
									<span v-if="showResumeValue()">R$ {{ this.totalAmountTaxes | currency }}</span>
								</td>
								<td v-else></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="desc">
				<span><b>Condições de pagamento:</b> {{ paymentCondition }}</span>
				<span><b>Observações:</b> {{ pedido.obs_pedido}}</span>
				<span><b>Tipo de Pedido:</b> {{ pedido.tipo == 1 ? 'Venda' : 'Consumo'}}</span>
			</div>
			<div class="box-extrato-do-pedido">
				<div class="title">Extrato do pedido</div>
				<div class="box-interacoes">
					<div>
						<i class="color-cinza"></i>
						<span>Interação do Representante</span>
					</div>
					<div>
						<i class="color-azul"></i>
						<span>Interação do Cliente</span>
					</div>
				</div>
			</div>
			<div class="box-tabela-responsavel" v-for="extrato in pedido.extrato">
				<div class="box-overflow">
					<table :class="extrato.user_cliente_id ? 'padrao header-cinza' : 'padrao header-azul'">
						<thead>
							<tr>
								<td colspan="4">Responsável: {{ extrato.usuario_cliente ? 'CLIENTE' : extrato.user_id ? 'REPRESENTANTE' : 'SISTEMA' }}</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><b>Autor:</b></td>
								<td>{{extrato.user_id ? extrato.usuario.first_name : (extrato.user_cliente_id ? pedido.cliente.desc_cliente : 'Sistema' )}}</td>
								<td><b>Data/Hora:</b></td>
								<td>{{ extrato.created_at }}</td>
							</tr>
							<tr>
								<td><b>Status:</b></td>
								<td v-if="extrato.status.slug === 'enviado' && !pedido.cliente.from_sap && !pedido.cliente.codigo">
                                  {{extrato.status.titulo}} - Cliente Novo
                                </td>
                                <td v-else>{{extrato.status.titulo }}</td>
								<td><b>Prazo de Resposta:</b></td>
								<td>{{ extrato.prazo_resposta }}</td>
							</tr>
							<tr>
								<td><b>Mensagem:</b></td>
								<td colspan="3">{{ extrato.mensagem }}
								</td>
							</tr>
							<tr v-if="extrato.anexos.length">
									<td colspan="4">
											<div class="group-btns-anexos">
												<a v-for="(anexo, key) in extrato.anexos" :href="root + '/public' + anexo.anexo" class="btn-download" download>
														<i>
														<img :src="root + '/public/images/icons/baixar-anexo.png'">
														</i>
														Anexo {{ ++key }}
												</a>
											</div>
									</td>
							</tr>
							<tr v-if="extrato.status.slug == 'ordem-venda-vinculada' && extrato.ordem">
								<td colspan="4">
									<table>
										<tr>
											<td class="cinza total-ordem" style="padding: 0px;">
												<strong>Valor Total líquido</strong>: R$ {{ formatarPreco(extrato.ordem.total_liquido) }} <br/>
												<strong>Total IPI</strong>: R$ {{ formatarPreco(extrato.ordem.total_ipi) }} <br/>
												<strong>Total ST</strong>: R$ {{ formatarPreco(extrato.ordem.total_subst) }} <br/>
												<strong>Total Redução Suframa</strong>: R$ {{ formatarPreco(extrato.ordem.reducao_suframa) }} <br/>
												<strong>Valor total frete</strong>: R$ {{ formatarPreco(extrato.ordem.frete_valor) }}<br/>
												<strong>Valor total com impostos</strong>: R$ {{ formatarPreco(extrato.ordem.total_nf) }} <br/>
											</td>
										</tr>
									</table>
								</td>
							</tr>
                        	<tr v-if="extrato.status.slug == 'nota-fiscal-vinculada' && extrato.nota">
								<td colspan="4">
									<table>
										<tr>
											<td class="cinza total-ordem" style="padding: 0px;">
												<strong>Valor Total produtos</strong>:
												R$ {{ formatarPreco(extrato.nota.valor_total_produtos) }}
												<br/>

												<strong>Total IPI</strong>:
												R$ {{ formatarPreco(extrato.nota.valor_total_ipi) }}
												<br/>

												<strong>Total ST</strong>:
												R$ {{ formatarPreco(extrato.nota.valor_total_icms_st) }}
												<br/>

												<strong>Total Redução Suframa</strong>:
												<br/>

												<strong>Valor total frete</strong>:
												R$ {{ formatarPreco(extrato.nota.valor_total_frete) }}
												<br/>

												<strong>Valor total com impostos</strong>:
												R$ {{ formatarPreco(extrato.nota.valor_total_nota) }}
												<br/>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
					<table class="itens-desc padrao" v-if="extrato.status.slug == 'ordem-venda-vinculada' && extrato.ordem">
						<tr v-if="extrato.ordem.itens.length > 0">
							<td>
								<strong>Item:</strong>
							</td>
							<td>
								<strong>Referência:</strong>
							</td>
							<td>
								<strong>Descrição:</strong>
							</td>
							<td>
								<strong>Qtd:</strong>
							</td>
							<td>
								<strong>Valor unitário:</strong>
							</td>
							<td>
								<strong>Valor total s/ impostos:</strong>
							</td>
							<td>
								<strong>Valor ICMS:</strong>
							</td>
							<td>
								<strong>Valor IPI:</strong>
							</td>
							<td>
								<strong>Valor ST:</strong>
							</td>
							<td>
								<strong>Valor total c/ impostos:</strong>
							</td>
							<td>
								<strong>Qtd. Atend:</strong>
							</td>
							<td>
								<strong>Qtd. Canc:</strong>
							</td>
							<td>
								<strong>Qtd. Pend:</strong>
							</td>
							<td>
								<strong>Status do Item:</strong>
							</td>
						</tr>
						<tr v-for="item in extrato.ordem.itens">
							<td>
								{{ item.item }}
							</td>
							<td>
								{{ formatarProtocolo(item.produto) }}
							</td>
							<td>
								{{ item.descricao }}
							</td>
							<td>
								{{ item.qtd }}
							</td>
							<td>
								R$ {{ formatarPreco(item.preco_liquido) }}
							</td>
							<td>
								R$ {{ formatarPreco(item.preco_total) }}
							</td>
							<td>
								R$ {{ formatarPreco(parseFloat(item.preco_total) / 100 * parseFloat(item.perc_icms)) }}
							</td>
							<td>
								R$ {{ formatarPreco(parseFloat(item.preco_total) / 100 * parseFloat(item.perc_ipi)) }}
							</td>
							<td>
									R$ {{ formatarPreco((parseFloat(item.preco_total) * (1+(parseFloat(item.perc_st_rf)/100))) - parseFloat(item.preco_total)) }}
							</td>
							<td>
								R$ {{ formatarPreco((parseFloat(item.preco_total)) + (parseFloat(item.preco_total) / 100 * parseFloat(item.perc_ipi)) + ((parseFloat(item.preco_total) * (1+(parseFloat(item.perc_st_rf)/100))) - parseFloat(item.preco_total))) }}
							</td>
							<td>
								{{ item.quantidadeAtendida }}
							</td>
							<td>
								{{ item.quantidadeCancelada }}
							</td>
							<td>
								{{ item.quantidadePendente }}
							</td>
							<td>
								{{ item.status }}
							</td>
						</tr>
					</table>
					<table class="itens-desc padrao" v-if="extrato.status.slug == 'nota-fiscal-vinculada' && extrato.nota">
						<tr v-if="extrato.nota.itens.length > 0">
							<td>
								<strong>Item:</strong>
							</td>
							<td>
								<strong>Referência:</strong>
							</td>
							<td>
								<strong>Descrição:</strong>
							</td>
							<td>
								<strong>Quantidade faturada:</strong>
							</td>
							<td>
								<strong>Valor unitário:</strong>
							</td>
							<td>
								<strong>Valor total s/ impostos:</strong>
							</td>
							<td>
								<strong>Valor ICMS:</strong>
							</td>
							<td>
								<strong>Valor IPI:</strong>
							</td>
							<td>
								<strong>Valor ST:</strong>
							</td>
							<td>
								<strong>Valor total c/ imposto:</strong>
							</td>
						</tr>
						<tr v-for="item in extrato.nota.itens">
							<td>
								{{ item.item }}
							</td>
							<td>
								{{ formatarProtocolo(item.produto) }}
							</td>
							<td>
								{{ item.descricao }}
							</td>
							<td>
								{{ item.qtd }}
							</td>
							<td>
								R$ {{ formatarPreco(item.preco_unit) }}
							</td>
							<td>
								R$ {{ formatarPreco(item.preco_tot_liq) }}
							</td>
							<td>
								R$ {{ formatarPreco(item.valor_icms) }}
							</td>
							<td>
								R$ {{ formatarPreco(item.valor_ipi) }}
							</td>
							<td>
								R$ {{ formatarPreco(item.valor_st) }}
							</td>
							<td>
								R$ {{ formatarPreco((parseFloat(item.preco_tot_liq) + parseFloat(item.valor_ipi) + parseFloat(item.valor_st))) }}
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div>
				<a :href="this.app + '/meus-pedidos'" class="btn-padrao btn-voltar">
					<i>
						<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
							<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
											d="M12.000,24.000 C5.372,24.000 -0.000,18.627 -0.000,12.000 C-0.000,5.373 5.372,-0.000 12.000,-0.000 C18.627,-0.000 24.000,5.373 24.000,12.000 C24.000,18.627 18.627,24.000 12.000,24.000 ZM17.130,10.882 L9.544,10.882 L13.308,7.148 C13.749,6.719 13.749,6.015 13.308,5.578 C12.875,5.141 12.166,5.141 11.725,5.578 L6.049,11.208 C6.019,11.230 5.997,11.260 5.974,11.290 C5.967,11.297 5.952,11.312 5.944,11.327 C5.930,11.349 5.915,11.364 5.907,11.379 C5.900,11.401 5.885,11.416 5.877,11.430 C5.862,11.445 5.855,11.460 5.847,11.475 C5.840,11.490 5.833,11.512 5.825,11.527 C5.817,11.542 5.810,11.556 5.803,11.571 C5.803,11.586 5.795,11.608 5.788,11.623 C5.788,11.638 5.780,11.660 5.773,11.675 C5.765,11.690 5.765,11.712 5.758,11.727 C5.750,11.742 5.743,11.756 5.743,11.779 C5.743,11.801 5.735,11.816 5.735,11.838 C5.735,11.860 5.728,11.875 5.728,11.890 C5.720,11.927 5.720,11.964 5.720,12.001 C5.720,12.038 5.728,12.075 5.728,12.112 C5.728,12.134 5.735,12.149 5.735,12.164 C5.735,12.186 5.735,12.201 5.743,12.223 C5.750,12.238 5.750,12.260 5.758,12.275 C5.765,12.290 5.765,12.312 5.773,12.327 C5.773,12.342 5.780,12.364 5.788,12.379 C5.788,12.401 5.795,12.416 5.803,12.431 C5.810,12.445 5.817,12.460 5.825,12.475 C5.833,12.490 5.840,12.512 5.847,12.527 C5.862,12.542 5.870,12.557 5.877,12.571 C5.885,12.594 5.900,12.608 5.907,12.623 C5.922,12.645 5.930,12.660 5.944,12.675 C5.952,12.682 5.967,12.697 5.974,12.712 C5.997,12.742 6.019,12.764 6.049,12.793 L11.725,18.424 C12.158,18.861 12.868,18.861 13.301,18.409 C13.741,17.980 13.741,17.276 13.301,16.839 L9.537,13.105 L17.130,13.105 C17.750,13.105 18.250,12.608 18.250,11.994 C18.250,11.379 17.750,10.882 17.130,10.882 Z"/>
						</svg> 
					</i>
					<span>VOLTAR</span>
				</a>
			</div>
			<div class="box-accordion">
				<a :href="app + '/meus-pedidos/continuar/' + pedido.id" class="btn-header-imprimir" v-if="pedido.rascunho_cliente == 1 && pedido.ultimo_status.titulo != 'Cancelado'">
					CONTINUAR ORÇAMENTO
				</a>
				<div v-if="pedido.rascunho_cliente == 0">
					<div class="header-accordion" id="bt1" @click="toggleForm(1)" v-if="pedido.rascunho_cliente == 0 && (pedido.nextStatus.indexOf('aguardando-representante') != -1 || statusSemInteracao.indexOf(pedido.ultimo_status.slug) == -1) && pedido.ultimo_status.titulo != 'Cancelado'">
						Interagir com o representante
						<i class="fas fa-caret-down"></i>
						<i class="fas fa-caret-up"></i>
					</div>
					<div class="content" id="content1">
						<div  v-if="statusSemInteracao.indexOf(pedido.ultimo_status.slug) != -1">
							<p class="center">Seu pedido foi enviado para a Atlas. Em caso de dúvidas, entre em contato com seu representante, através dos contatos: </p>
							<br>
							<p class="center">{{ (pedido.representante.site.contatos.length > 0 && pedido.representante.site.contatos.findIndex(element => element['tipo'] == 'email') >= 0) ? pedido.representante.site.contatos[pedido.representante.site.contatos.findIndex(element => element['tipo'] == 'email')]['valor'] : ''}}</p>
							<br>
							<p class="center">{{ (pedido.representante.site.contatos.length > 0 && pedido.representante.site.contatos.findIndex(element => element['tipo'] == 'telefone') >= 0) ? pedido.representante.site.contatos[pedido.representante.site.contatos.findIndex(element => element['tipo'] == 'telefone')]['valor'] : ''}}</p>
							<br>
						</div>
						<div v-else>
							<v-form-interacao :interacao="1" @sendStatus="sendStatus" @updateFile="updateFile"></v-form-interacao>
						</div>
					</div>
					<div class="header-accordion" id="bt2" @click="toggleForm(2)" v-if="pedido.nextStatus.indexOf('orcamento-aprovado') != -1 && pedido.rascunho == 0">
						<i class="svg">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="26px" height="26px">
								<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
									d="M13.049,-0.000 C20.157,-0.000 26.000,5.842 26.000,13.048 C26.000,20.157 20.157,26.000 13.049,26.000 C5.843,26.000 -0.000,20.157 -0.000,13.048 C-0.000,5.842 5.843,-0.000 13.049,-0.000 ZM5.551,14.899 C4.285,13.633 6.135,11.685 7.401,12.854 L10.225,15.483 L18.599,7.693 C19.865,6.524 21.715,8.472 20.449,9.640 L11.198,18.307 C10.614,18.794 9.835,18.794 9.348,18.307 L5.551,14.899 ZM13.049,1.363 C6.622,1.363 1.363,6.622 1.363,13.048 C1.363,19.475 6.622,24.636 13.049,24.636 C19.476,24.636 24.637,19.475 24.637,13.048 C24.637,6.622 19.476,1.363 13.049,1.363 Z"/>
							</svg>
						</i>
						Aprovar orçamento
						<i class="fas fa-caret-down"></i>
						<i class="fas fa-caret-up"></i>
					</div>
					<div class="content" id="content2" v-if="pedido.nextStatus.indexOf('orcamento-aprovado') != -1 && pedido.rascunho == 0">
						<v-form-interacao :interacao="2" @sendStatus="sendStatus" @updateFile="updateFile"></v-form-interacao>
					</div>
					<div class="header-accordion" id="bt3" @click="toggleForm(3)" v-if="pedido.nextStatus.indexOf('orcamento-reprovado') != -1 && pedido.rascunho == 0">
						<i class="svg">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="26px" height="26px">
								<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
									d="M13.049,26.000 C5.843,26.000 -0.000,20.157 -0.000,13.049 C-0.000,5.842 5.843,-0.000 13.049,-0.000 C20.157,-0.000 26.000,5.842 26.000,13.049 C26.000,20.157 20.157,26.000 13.049,26.000 ZM13.049,1.363 C6.622,1.363 1.363,6.621 1.363,13.049 C1.363,19.475 6.622,24.636 13.049,24.636 C19.476,24.636 24.637,19.475 24.637,13.049 C24.637,6.621 19.476,1.363 13.049,1.363 ZM13.500,22.000 C12.672,22.000 12.000,21.328 12.000,20.500 C12.000,19.672 12.672,19.000 13.500,19.000 C14.328,19.000 15.000,19.672 15.000,20.500 C15.000,21.328 14.328,22.000 13.500,22.000 ZM13.500,17.000 C12.672,17.000 12.000,16.328 12.000,15.500 L12.000,5.500 C12.000,4.671 12.672,4.000 13.500,4.000 C14.328,4.000 15.000,4.671 15.000,5.500 L15.000,15.500 C15.000,16.328 14.328,17.000 13.500,17.000 Z"/>
							</svg>
						</i>
						Revisar/Alterar Orçamento
						<i class="fas fa-caret-down"></i>
						<i class="fas fa-caret-up"></i>
					</div>
					<div class="content" id="content3" v-if="pedido.nextStatus.indexOf('orcamento-reprovado') != -1 && pedido.rascunho == 0">
						<v-form-interacao :interacao="3" @sendStatus="sendStatus" @updateFile="updateFile"></v-form-interacao>
					</div>
				</div>
				<div class="header-accordion cancelar" id="bt4" @click="toggleForm(4)" v-if="pedido.nextStatus.indexOf('cancelado') != -1">
					<i class="svg">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="26px" height="26px">
							<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
								d="M13.049,26.000 C5.843,26.000 -0.000,20.157 -0.000,13.049 C-0.000,5.842 5.843,-0.000 13.049,-0.000 C20.157,-0.000 26.000,5.842 26.000,13.049 C26.000,20.157 20.157,26.000 13.049,26.000 ZM13.049,1.363 C6.622,1.363 1.363,6.621 1.363,13.049 C1.363,19.475 6.622,24.636 13.049,24.636 C19.476,24.636 24.637,19.475 24.637,13.049 C24.637,6.621 19.476,1.363 13.049,1.363 ZM18.637,18.604 L18.604,18.637 C18.150,19.092 17.406,19.092 16.952,18.637 L13.000,14.685 L9.048,18.637 C8.593,19.092 7.850,19.092 7.395,18.637 L7.362,18.604 C6.908,18.150 6.908,17.406 7.362,16.952 L11.315,13.000 L7.362,9.048 C6.908,8.593 6.908,7.850 7.362,7.395 L7.395,7.362 C7.850,6.908 8.593,6.908 9.048,7.362 L13.000,11.314 L16.952,7.362 C17.406,6.908 18.150,6.908 18.604,7.362 L18.637,7.395 C19.092,7.850 19.092,8.593 18.637,9.048 L14.685,13.000 L18.637,16.952 C19.092,17.406 19.092,18.150 18.637,18.604 Z"/>
						</svg>
					</i>
					CANCELAR
					<i class="fas fa-caret-down"></i>
					<i class="fas fa-caret-up"></i>
				</div>
				<div class="content" id="content4" v-if="pedido.nextStatus.indexOf('cancelado') != -1">
					<v-form-interacao :interacao="4" @sendStatus="sendStatus" @updateFile="updateFile"></v-form-interacao>
				</div>
				<a :href="app + '/api/meus-pedidos/imprimir/' + pedido.id" class="btn-header-imprimir" v-if="pedido.rascunho == 0 && pedido.rascunho_cliente == 0">
					<i class="svg">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="26px" height="26px">
							<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
								d="M22.196,22.196 C19.842,24.545 16.588,26.000 13.003,26.000 C9.412,26.000 6.158,24.545 3.809,22.196 C1.455,19.842 -0.000,16.588 -0.000,13.002 C-0.000,9.411 1.455,6.158 3.809,3.809 C6.158,1.455 9.412,-0.000 13.003,-0.000 C16.588,-0.000 19.842,1.455 22.196,3.809 C24.545,6.158 26.000,9.411 26.000,13.002 C26.000,16.588 24.545,19.842 22.196,22.196 ZM21.427,4.573 C19.270,2.416 16.292,1.086 13.003,1.086 C9.708,1.086 6.730,2.416 4.573,4.573 C2.417,6.730 1.086,9.708 1.086,13.002 C1.086,16.292 2.417,19.270 4.573,21.427 C6.730,23.583 9.708,24.919 13.003,24.919 C16.292,24.919 19.270,23.583 21.427,21.427 C23.583,19.270 24.919,16.292 24.919,13.002 C24.919,9.708 23.583,6.730 21.427,4.573 ZM19.587,18.750 L17.612,18.750 L17.612,20.335 C17.612,20.637 17.368,20.881 17.067,20.881 L8.933,20.881 C8.632,20.881 8.393,20.637 8.393,20.335 L8.393,18.750 L6.413,18.750 C6.117,18.750 5.872,18.506 5.872,18.205 L5.872,11.553 C5.872,11.251 6.117,11.007 6.413,11.007 L8.393,11.007 L8.393,5.534 C8.393,5.233 8.632,4.994 8.933,4.994 L17.067,4.994 C17.368,4.994 17.612,5.233 17.612,5.534 L17.612,11.007 L19.587,11.007 C19.888,11.007 20.127,11.251 20.127,11.553 L20.127,18.205 C20.127,18.506 19.888,18.750 19.587,18.750 ZM9.474,19.795 L16.526,19.795 L16.526,16.474 L9.474,16.474 L9.474,19.795 ZM16.526,6.075 L9.474,6.075 L9.474,11.007 L16.526,11.007 L16.526,6.075 ZM19.047,12.093 L17.067,12.093 L8.933,12.093 L6.959,12.093 L6.959,17.664 L8.393,17.664 L8.393,15.933 C8.393,15.637 8.632,15.393 8.933,15.393 L17.067,15.393 C17.368,15.393 17.612,15.637 17.612,15.933 L17.612,17.664 L19.047,17.664 L19.047,12.093 ZM16.635,13.605 C16.635,13.236 16.937,12.935 17.306,12.935 C17.680,12.935 17.976,13.236 17.976,13.605 C17.976,13.974 17.680,14.276 17.306,14.276 C16.937,14.276 16.635,13.974 16.635,13.605 Z"/>
						</svg>
					</i>
					IMPRIMIR
				</a>
			</div>
		</div>
		<vue-element-loading :active="loading" is-full-screen></vue-element-loading>
	</div>
</template>
<script>
	export default {
		props: {
			protocolo: String,
			isCustomerTypeSale: Number,
		},
		data() {
			return {
				loading: false,
				loadingSave: false,
				pedido: {
					cliente: {},
					representante: {},
					produtos: [],
					nextStatus: []
				},
				statusSemInteracao: [
					'em-execucao', 
					'concluido', 
					'ordem-venda-vinculada', 
					'nota-fiscal-vinculada', 
					'observacoes-internas'
				],
				file: '', 
				root: ROOT_URL,
				app: APP_URL,
				filters : []
			}
		},
		computed: {		
			paymentCondition: function() {
				const order = this.pedido;
				const paymentCondition = order.condicoes_pagamento ? order.condicoes_pagamento.desc_cond_pagto : '';

				if (order.cliente_tipo_venda) {
					return paymentCondition;
				}

				return order.orcado ? paymentCondition : 'Aguardando Representante';
			},	
			descontosCabecalho: function () {
				var desc2 = this.pedido.desconto_2 ? this.pedido.desconto_2 : 0;
				var desc4 = this.pedido.desconto_4 ? this.pedido.desconto_4 : 0;
				return (100 - Math.round(Math.round(100 * (100 - desc2)) / 100 * (100 - desc4)) / 100).toFixed(2);
			},
			verPreco: function () {
				return parseInt(this.pedido.orcado) == 1 && parseInt(this.pedido.rascunho) == 0 && this.pedido.ultimo_status.slug !== 'orcamento-enviado-preposto'
			},
			totalAmount: function () {
				var totalGeral = 0;
				var totalItem = 0;
				var vm = this;
					
				$.each(this.pedido.produtos, function(key, value) {
					totalItem = value.preco_bruto * (100 - parseFloat(vm.descontosCabecalho)) /100; 
					totalItem = totalItem * (100 - parseFloat(value.desconto)) / 100;
					totalItem = Math.round(totalItem * (100 + parseFloat(value.acrescimo))) / 100;
					totalItem = totalItem * value.quantidade;
						
					if (!isNaN(totalItem)) {
						totalGeral += parseFloat(totalItem);
					}
				});
						
				return totalGeral;
			},
			totalAmountTaxes: function () {

				var totalGeral = this.totalAmount + this.totalSt + this.totalIpi;
				return totalGeral;
			},
			totalIpi: function () {
				var totalGeral = 0;
				var totalItem = 0;
				var vm = this;

				$.each(this.pedido.produtos, function(key, value) {
					totalItem = Math.round(value.preco_bruto * (100 - parseFloat(vm.descontosCabecalho))) /100; 
					totalItem = Math.round(totalItem * (100 - parseFloat(value.desconto))) / 100;
					totalItem = Math.round(totalItem * (100 + parseFloat(value.acrescimo))) / 100;
					totalItem = totalItem * value.quantidade;
					totalItem = Math.round(totalItem * (parseFloat(value.perc_ipi))) / 100;					
					if (!isNaN(totalItem)) {
						totalGeral += parseFloat(totalItem);
					}
				});

				return totalGeral;
			},            
			totalSt: function () {
				var totalGeral = 0;
				var totalItem = 0;
				var vm = this;

				if (this.pedido.tipo == 1)
				{
					$.each(this.pedido.produtos, function(key, value) {
						totalItem = Math.round(value.preco_bruto * (100 - parseFloat(vm.descontosCabecalho))) /100; 
						totalItem = Math.round(totalItem * (100 - parseFloat(value.desconto))) / 100;
						totalItem = Math.round(totalItem * (100 + parseFloat(value.acrescimo))) / 100;
						totalItem = totalItem * value.quantidade;
						totalItem = Math.round(totalItem * (parseFloat(value.perc_st))) / 100;
						if (!isNaN(totalItem)) {
							totalGeral += parseFloat(totalItem);
						}
					});
				}
				return totalGeral;
			},                            
		},
		methods: {
			changeQuantity(product, action) 
			{
				this.pedido.produtos = this.pedido.produtos.map((produto) => {
					if (produto.id === product.id) {
						if (action === 'add') {
							produto.quantidade += parseInt(produto.produto.embalagem);
						}						

						if (action === 'remove') {							
							produto.quantidade -= parseInt(produto.produto.embalagem);

							if (produto.quantidade <= 0) {
								produto.quantidade = parseInt(produto.produto.embalagem);
							}
						}
					}

					return produto;
				});
			},			
			canEdit() {
				return this.pedido.nextStatus.indexOf('orcamento-aprovado') != -1 && this.pedido.ultimo_status.titulo != 'Cancelado'
			},
			showValue(product)
			{
				if (this.pedido.cliente_tipo_venda) {
					return true
				}

				if (product.new_item_order) {
					return false
				}

				return parseInt(this.pedido.orcado) == 1 && parseInt(this.pedido.rascunho) == 0 && this.pedido.ultimo_status.slug !== 'orcamento-enviado-preposto'
			},
			showResumeValue()
			{
				if (this.pedido.cliente_tipo_venda) {
					return true
				}

				const haveNewItem = this.pedido.produtos.some(product => product.new_item_order)

				if (haveNewItem) {
					return false
				}

				return parseInt(this.pedido.orcado) == 1 && parseInt(this.pedido.rascunho) == 0 && this.pedido.ultimo_status.slug !== 'orcamento-enviado-preposto'
			},
			changeFiltros(filtros) {
				this.filters = filtros;
				filtros = JSON.stringify(filtros[0]);
				filtros = filtros.replace('/', '*');
				filtros = filtros.replace('/', '*');
				filtros = filtros.replace('/', '*');
				filtros = filtros.replace('/', '*');
				window.location = APP_URL + '/meus-pedidos/' + filtros;
			},
			loadInfo() {
				this.axios.post(API_URL + '/meus-pedidos/detalhes', {'protocolo' : this.protocolo})
					.then(({data}) =>
					{
						this.pedido = data;
						this.loading = false;
					}
				)
			},
			formatarProtocolo(value)
			{
				if(isNaN(value))
				{
					return value;
				}
				else
				{
					return parseInt(value);
				}
			},
			formatarPreco(amount, decimalCount = 2, decimal = ',', thousands = '.') 
			{
				try 
				{
					decimalCount = Math.abs(decimalCount);
					decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

					const negativeSign = amount < 0 ? "-" : "";

					let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
					let j = (i.length > 3) ? i.length % 3 : 0;

					return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
				} catch (e) 
				{
					console.log(e)
				}
			},
			formatarValor(value) {
				return value.toString().replace('.', ',');
			},
			getTotal(item, imposto = false)
			{
				var tt = item.preco_bruto ?
					Math.round(
						Math.round(
							(
								(item.preco_bruto * (100 - parseFloat(this.descontosCabecalho))) /100 * (100 - item.desconto)
							) / 100 * (100 + parseFloat(item.acrescimo))
						) / 100 * item.quantidade * 100
					) / 100
				: 0;
				if (imposto)
				{
					if (this.pedido.tipo == 1)
					{
						tt =  Math.round(
								tt * (100 + parseFloat(item.perc_ipi) + parseFloat(item.perc_st))
						) / 100
					}
					else 
					{
						tt =  Math.round(
								tt * (100 + parseFloat(item.perc_ipi))
						) / 100
					}
				}
				return tt;
			},
			getPrecoLiquido(item)
			{			
				return item.preco_bruto ?
                    Math.round(
                        Math.round(
                            (item.preco_bruto * (100 - parseFloat(this.descontosCabecalho))) /100 * (100 - item.desconto)
                        ) / 100 * (100 + parseFloat(item.acrescimo))
                    ) / 100
                    : 0;				
			},
			toggleForm(form) {
				$('#bt' + form).toggleClass("expand");
				$('#content' + form).slideToggle(300);
			},
			updateFile(file) {
				this.file = file;
			},
			removeItem(product)
			{
				let vm = this;

				this.axios.post(API_URL + '/meus-pedidos/remove-item', {
                    'product': product, 
                    'pedidoId': this.pedido.id
                }).then((data) => 	{
					vm.pedido.produtos = vm.pedido.produtos.filter(produto => produto.id !== product.id);

					vm.$toasted.show(data.data, {
						type: "success",
						duration: 4000
					})					
				}).catch((error) => {
					vm.$toasted.show(error.response.data, {
						type: "error",
						duration: 4000
					})
				})
			},
			updateQuantity(product, action)
			{
				let vm = this;

				this.axios.post(API_URL + '/meus-pedidos/atualiza-item', {
                    'product': product, 
                    'pedidoId': this.pedido.id
                }).then((data) => 	{					
					vm.changeQuantity(product, action)

					vm.$toasted.show(data.data, {
						type: "success",
						duration: 4000
					})
				}).catch((error) => {
					vm.$toasted.show(error.response.data, {
						type: "error",
						duration: 4000
					})
				})
			},
			sendStatus(data) {
				var vm = this;
				let formData = new FormData();
				if (this.file.files) {
					for( var i = 0; i < this.file.files.length; i++ ){
						let file = this.file.files[i];
						formData.append('files[' + i + ']', file);
					}
				}

				formData.append("mensagem", data.message);
				formData.append("pedidoId", this.pedido.id);
				
				var url;
				switch (data.interacao) {
					case 1:
						url = '/meus-pedidos/interacao';
						break;
				case 2:
						url = '/meus-pedidos/aprovar-orcamento';
						break;
				case 3:
						url = '/meus-pedidos/reprovar-orcamento';
						break;
				case 4:
						url = '/meus-pedidos/cancelar-orcamento';
						break;
				}
				this.loading = true;
				this.axios
					.post(API_URL + url, formData, {
						headers: {
							"Content-Type": "multipart/form-data"
						}
					})
					.then(function(response) {
						if (response.erro) {
							vm.$toasted.error(response.erro, {duration:3000, keepOnHover: true, icon:'exclamation-circle'});
						} else {
							vm.loadInfo();
							vm.loading = false;
							vm.file = '';
							$('.expand').click();
						}
					})
					.catch(function(error) {
						vm.loading = false;
					});
				},
			},
		mounted() {
			this.loadInfo();
		}	
	}
</script>